import React from "react";
import { Col } from "reactstrap";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";


const AuthSlider = () => {
    return (
        <React.Fragment>
            <Col xs={12} lg={6} className="order-1">
                <div className="p-lg-5 p-4 auth-one-bg auth-slider-panel">
                    <div className="bg-overlay"></div>
                    <div className="position-relative h-100 d-flex flex-column">
                        <div className="mt-auto">
                            <div className="mb-3">
                                <i className="ri-double-quotes-l display-4 text-secondary"></i>
                            </div>

                            <Carousel showThumbs={false} autoPlay={true} showArrows={false} showStatus={false} infiniteLoop={true} className="slide auth-carousel">
     <div className="carousel-inner text-center text-white-50 auth-carousel-slide">
                                    <div className="item">
                                        <img src="/login1.png" alt="" className="auth-carousel-img" style={{ maxHeight: '280px', width: 'auto', objectFit: 'contain' }} />
                                        <p className="auth-carousel-title">Expense Tracker</p>
                                        <p className="auth-carousel-desc">Record your daily transactions within seconds.</p>
                                    </div>
                                </div>
                                <div className="carousel-inner text-center text-white-50 auth-carousel-slide">
                                    <div className="item">  
                                        <img src="/login2.png" alt="" className="auth-carousel-img" style={{ maxHeight: '280px', width: 'auto', objectFit: 'contain' }} />
                                        <p className="auth-carousel-title">Financial Well Being</p>
                                        <p className="auth-carousel-desc">Set budgets that are easy to stick to, based on your own spending habits.</p>
                                    </div>
                                </div>
                                <div className="carousel-inner text-center text-white-50 auth-carousel-slide">
                                    <div className="item">  
                                        <img src="/login3.png" alt="" className="auth-carousel-img" style={{ maxHeight: '280px', width: 'auto', objectFit: 'contain' }} />
                                        <p className="auth-carousel-title">Visualize Expenses</p>
                                        <p className="auth-carousel-desc">Understand where your money comes and goes with easy-to-read graphs.</p>
                                    </div>
                                </div>
                              
                            </Carousel>

                        </div>
                    </div>
                </div>
            </Col>
        </React.Fragment >
    );
};

export default AuthSlider;